import { ReportBlockTypeEnum } from '../enums/report-block-type.enum';


export const reportsBlockTypesToAnnotationAdjustMap = new Map<ReportBlockTypeEnum, [number, number, number]>([
    [ReportBlockTypeEnum.COVERAGE_OVER_TIME, [-15, 10, 5]],
    [ReportBlockTypeEnum.COVERAGE_OVER_TIME_COMPARISON, [-15, 10, 5]],
    [ReportBlockTypeEnum.COVERAGE_IMPACT_TREND, [-10, 5, 5]],
    [ReportBlockTypeEnum.TOP_10_AUTHORS_BY_VOLUME, [-10, -20, 5]],
    [ReportBlockTypeEnum.TOP_10_OUTLETS, [-10, -20, 5]],
    [ReportBlockTypeEnum.TOP_HASHTAGS, [-10, -20, 5]],
    [ReportBlockTypeEnum.TOP_SOCIAL_REFERRERS, [-10, -20, 5]]
]);

export const canvasBlockTypesToAnnotationAdjustMap = new Map<ReportBlockTypeEnum, [number, number, number]>([
    [ReportBlockTypeEnum.COVERAGE_OVER_TIME, [-15, 10, 5]],
    [ReportBlockTypeEnum.COVERAGE_OVER_TIME_COMPARISON, [-15, 10, 5]],
    [ReportBlockTypeEnum.TOP_10_AUTHORS_BY_VOLUME, [-10, -20, 0]],
    [ReportBlockTypeEnum.TOP_10_OUTLETS, [-10, -20, 0]],
    [ReportBlockTypeEnum.TOP_HASHTAGS, [-10, -20, 0]]
]);

export const emailBriefingsBlockTypesToAnnotationAdjustMap = new Map<ReportBlockTypeEnum, [number, number, number]>([
    [ReportBlockTypeEnum.COVERAGE_OVER_TIME, [-10, 5, 15]],
    [ReportBlockTypeEnum.COVERAGE_OVER_TIME_COMPARISON, [-10, 8, 15]],
    [ReportBlockTypeEnum.TOP_10_AUTHORS_BY_VOLUME, [-5, -10, 0]],
    [ReportBlockTypeEnum.TOP_10_OUTLETS, [-5, -10, 0]],
    [ReportBlockTypeEnum.TOP_HASHTAGS, [-5, -10, 0]]
]);

export const reportsBlockTypesToInDialogAnnotationAdjustMap = new Map<ReportBlockTypeEnum, [number, number, number]>([
    [ReportBlockTypeEnum.COVERAGE_OVER_TIME, [-15, 10, 5]],
    [ReportBlockTypeEnum.COVERAGE_OVER_TIME_COMPARISON, [-15, 10, 5]],
    [ReportBlockTypeEnum.COVERAGE_IMPACT_TREND, [-10, 5, 5]],
    [ReportBlockTypeEnum.TOP_10_AUTHORS_BY_VOLUME, [-5, 0, 0]],
    [ReportBlockTypeEnum.TOP_10_AUTHORS_BY_VOLUME, [-5, 0, 0]],
    [ReportBlockTypeEnum.TOP_10_OUTLETS, [-5, 0, 0]],
    [ReportBlockTypeEnum.TOP_HASHTAGS, [-5, 0, 0]],
    [ReportBlockTypeEnum.TOP_SOCIAL_REFERRERS, [-5, 0, 0]]
]);

export const canvasBlockTypesToInDialogAnnotationAdjustMap = new Map<ReportBlockTypeEnum, [number, number, number]>([
    [ReportBlockTypeEnum.COVERAGE_OVER_TIME, [-10, 5, 15]],
    [ReportBlockTypeEnum.COVERAGE_OVER_TIME_COMPARISON, [-10, 8, 15]],
    [ReportBlockTypeEnum.TOP_10_AUTHORS_BY_VOLUME, [-10, -10, 0]],
    [ReportBlockTypeEnum.TOP_10_AUTHORS_BY_VOLUME, [-10, -10, 0]],
    [ReportBlockTypeEnum.TOP_10_OUTLETS, [-10, -10, 0]],
    [ReportBlockTypeEnum.TOP_HASHTAGS, [-10, -10, 0]]
]);

export const emailBriefingsBlockTypesToInDialogAnnotationAdjustMap = new Map<ReportBlockTypeEnum, [number, number, number]>([
    [ReportBlockTypeEnum.COVERAGE_OVER_TIME, [-10, 5, 15]],
    [ReportBlockTypeEnum.COVERAGE_OVER_TIME_COMPARISON, [-10, 8, 15]],
    [ReportBlockTypeEnum.TOP_10_AUTHORS_BY_VOLUME, [-5, -10, 15]],
    [ReportBlockTypeEnum.TOP_10_AUTHORS_BY_VOLUME, [-5, -10, 15]],
    [ReportBlockTypeEnum.TOP_10_OUTLETS, [-5, -10, 15]],
    [ReportBlockTypeEnum.TOP_HASHTAGS, [-5, -10, 15]]
]);
